import { gql } from "@apollo/client";

export const getAssignationTypesByLink = gql`
  query getAssignationTypesByLink(
    $scenarioId: ID!
    $originId: ID!
    $filter: AssignationTypeFilterInput
  ) {
    data(scenarioId: $scenarioId, originId: $originId) {
      assignationTypes(filter: $filter) {
        items {
          id
          code
          name
          maxAssignmentsByLink
        }
        pageInfo {
          total
        }
      }
    }
  }
`;
